export enum Role {
  Admin = 'Super Administrador',
  Inmob = 'Inmobiliaria',
  Agent = 'Agente'
}
